import { create } from "zustand"
import { createJSONStorage, persist } from "zustand/middleware"

type State = {
  isPrivateModeEnabled: boolean
  authenticatedIntentsUserId: string | null
}

type Actions = {
  setPrivateModeEnabled: (enabled: boolean) => void
  togglePrivateMode: () => void
}

type Store = State & Actions

export const usePrivateModeStore = create<Store>()(
  persist(
    (set, get) => ({
      isPrivateModeEnabled: false,
      authenticatedIntentsUserId: null,
      setPrivateModeEnabled: (enabled) => {
        set({ isPrivateModeEnabled: enabled })
      },
      togglePrivateMode: () => {
        set({ isPrivateModeEnabled: !get().isPrivateModeEnabled })
      },
    }),
    {
      name: "app_private_mode",
      storage: createJSONStorage(() => localStorage),
    }
  )
)
